import { batchArray } from '~/utils'

import { ArticleListItem } from './ArticlesList.types'

export default function useArticlesList(articles: ArticleListItem[]): {
  latest: ArticleListItem
  rest: ArticleListItem[]
  restChunkedWithIteratorKey: Array<{
    key: string
    articles: ArticleListItem[]
  }>
} {
  const latest = articles[0]
  const rest = articles.slice(1)

  const restChunkedWithIteratorKey = batchArray(rest, 3).map((elem, index) => ({
    key: String(index),
    articles: elem,
  }))

  return {
    latest,
    rest,
    restChunkedWithIteratorKey,
  }
}
